module.exports = __webpack_public_path__ + "static/media/18ECA41.5e4990f3.jpg";